import { actionTypes } from "../../../types";

const initialState = {
    loading: false,
    status: '',
    message: '',
    data: [],
}

export default (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.PUBLISH_VIDEO_ON_YOUTUBE_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case actionTypes.PUBLISH_VIDEO_ON_YOUTUBE_SUCCESS:
            return {
                ...state,
                loading: false,
                status: action?.payload?.status,
                message: action?.payload?.message,
                data: action?.payload?.response
            }
        case actionTypes.PUBLISH_VIDEO_ON_YOUTUBE_FAILURE:
            return {
                ...state,
                loading: false,
                status: action?.payload?.status,
                message: action?.payload?.message,
            }
        case actionTypes.PUBLISH_VIDEO_ON_YOUTUBE_RESET:
            return {
                ...state,
                status: '',
                message: ''
            }
        case actionTypes.PUBLISH_VIDEO_ON_YOUTUBE_RESET_ALL:
            return initialState
        default:
            return state;
    }
};
